module.exports = __webpack_public_path__ + "img/emmy.210eb27c.jpeg";